import React from 'react'

function Image({imgsrc}) {
  return (
    <img src={imgsrc}/>
  )
}

export default Image